import { forEach } from 'lodash'
import { UseFormReturn } from 'react-hook-form/dist/types'
import { useSetRecoilState } from 'recoil'

import { dialogState } from '@/components/Context/DialogProvider'
import { jwtTokenState, loginUserState } from '@/components/Context/JwtTokenProvider'
import { useSmoothScroll } from '@/components/hooks/useSmoothScroll'
import { LoginSessionType } from '@/types/loginSession'
import { ErrorType } from '@/types/request/errorResponse'

export const useProcessResponse = (form: UseFormReturn) => {
  const setRecoilLoginSession = useSetRecoilState(jwtTokenState)
  const setRecoilLoginUser = useSetRecoilState(loginUserState)
  const setDialog = useSetRecoilState(dialogState)
  const { scrollTo } = useSmoothScroll()

  const processSuccessResponse = ({
    loginSession = null,
    after = () => {},
  }: {
    loginSession?: LoginSessionType | null
    after: () => void
  }) => {
    if (loginSession != null) {
      setRecoilLoginSession(true)
      setRecoilLoginUser(loginSession.user)
    }

    after()
  }

  const processErrorResponse = (errors: ErrorType, alertMessage: string) => {
    if (errors != null) {
      scrollTo(`#${Object.keys(errors)[0]}`)
      forEach(errors, (error, key) => {
        // @ts-ignore
        form.setError(key, error)
      })
      if (errors.message != null) {
        if (errors.dialog != null) {
          setDialog({
            message: errors.message!,
            title: errors.dialog.title,
            href: errors.dialog.href,
            buttonText: errors.dialog.buttonText,
          })
        } else {
          alert(errors.message)
        }
      } else if (errors.errorCount === 0) {
        alert(alertMessage)
      }
    }
  }

  return {
    processSuccessResponse,
    processErrorResponse,
  }
}
